/* eslint-env browser */
import * as React from 'react'

import { getCDNUrl } from '../../../../../../shared/services/media-helper'

const PropTypes = require('prop-types')

const EmptyImagesGenerator = require('../../../../../../shared/services/empty-images-generator')

class UserItem extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { user } = this.props

    let imgUrl
    if (user.profilePicture) {
      imgUrl = getCDNUrl(user.profilePicture, 'small')
    } else if (user.profilePictureURL) {
      imgUrl = user.profilePictureURL
    }
    if (!imgUrl) {
      imgUrl = EmptyImagesGenerator.getUserPlaceholder({ userId: user.id })
    }

    return (
      <div style={{ textAlign: 'center' }} className="animated fadeIn">
        <a href={`/users/${user.id}`} target="_blank" rel="noopener noreferrer">
          <figure className="image is-square has-hover-overlay is-overflow-hidden is-rounded">
            <img className="has-object-fit-cover" src={imgUrl} alt="" />
          </figure>
        </a>
      </div>
    )
  }
}

UserItem.propTypes = {
  user: PropTypes.object.isRequired,
}

UserItem.defaultProps = {}

module.exports = UserItem
